import React, { Component, Fragment } from 'react'

import UpdateTodo from './UpdateTodo';
import TodoDetails from './TodoDetails';

const colors = ["linear-gradient(to right, #b8cbb8 0%, #b8cbb8 0%, #b465da 0%, #cf6cc9 33%, #ee609c 66%, #ee609c 100%)", "linear-gradient(to top, #37ecba 0%, #72afd3 100%)", "linear-gradient(to top, #d299c2 0%, #fef9d7 100%)"];
function randomColor() {
    const randomNumber = Math.floor(Math.random() * colors.length);

    return colors[randomNumber];
}

export class Todo extends Component {
    constructor(props) {
        super(props)
        this.todoContainerRef = React.createRef();
        this.state = {
            isUpdateOpen: false,
        }
    }

    componentDidMount() {
        document.querySelector(".todo-container").addEventListener("click", this.completeTodo)
    }

    componentDidUpdate(props, state) {
        // to re-listen to click event on todo container in order to complete or uncomplete it
        if (this.state.isUpdateOpen == false) {
            this.todoContainerRef.current.addEventListener("click", this.completeTodo)
        }
    }

    deleteTodoHandler = () => {
        this.props.deleteTodo(this.props.todo.id)
    }

    updateOpenHandler = () => {
        this.setState({
            isUpdateOpen: true,
        })
    }

    cancelUpdateHanlder = () => {
        this.setState({
            isUpdateOpen: false
        })
    }

    updateTodoSubmissionHandler = () => {
        this.cancelUpdateHanlder();
        this.props.updateTodoSubmission(this.props.todo.id);
    }

    completeTodo = (e) => {
        const targetEle = e.target;
        if (!targetEle.classList.contains("delete-todo") && !targetEle.classList.contains("edit-todo") && !targetEle.classList.contains("todo-details")) {
            if (this.todoContainerRef.current.contains(targetEle)) {
                this.props.completeTodo(this.props.todo.id)
            }
        }
    }

    render() {
        const { id, body, completed } = this.props.todo;
        const isUpdateOpen = this.state.isUpdateOpen;
        let updateOrShow;

        if (isUpdateOpen) {
            updateOrShow = <UpdateTodo key={id} cancelUpdate={this.cancelUpdateHanlder} todoId={id} updateTodoSubmission={this.updateTodoSubmissionHandler} updateTodoText={this.props.updateText} todoText={this.props.todoText} currentTodoBody={body} />
        } else {
            updateOrShow = <>
                <div ref={this.todoContainerRef} className="todo-container" style={{ background: randomColor() }}>
                    <span className={completed ? "todo-body completed" : "todo-body"}>{body}</span>
                    <div className="todo-controls">
                        <i onClick={this.deleteTodoHandler} className="far fa-trash-alt delete-todo" />
                        {!completed ? <i className="far fa-edit edit-todo" onClick={this.updateOpenHandler} /> : null}
                    </div>
                </div>
            </>
        }

        return updateOrShow
    }
}

export default Todo
